// extracted by mini-css-extract-plugin
export default {"moveAmount":"_3GOVG"};